export const DO_IT = 'DO_IT'
export const GET_API = 'GET_API'
export const ON_LOADING = 'ON_LOADING'
export const OFF_LOADING = 'OFF_LOADING'
